import React, { useState } from 'react';
import { useSelector } from 'react-redux';
/* import moment from 'moment'; */
import { PropTypes } from 'prop-types';
import { Badge, Button } from 'react-bootstrap';
import ProductModal from '../../../Modals/ProductModal/ProductModal';
import { useTranslation } from 'react-i18next';

import { getUploadsBaseUrl } from '../../../../api/axiosInstance';;

function ProductListItem(props) {
    const { product, eventID, partnerPortalSettings, vat, addProductToCart, removeProductFromCart, portalClosed } = props;
    const { userCanEditOrders } = partnerPortalSettings;
    const [ modalShow, setModalShow ] = useState(false);
    const cart = useSelector(({ cart }) => cart);
    const { addedProducts, order } = cart;
    const { orderRows } = order;
    const isAdded = addedProducts.findIndex(p => p.productID === product.productID && p.status === 5) > -1;
    const { t } = useTranslation();

    const addToCartDisabled = (product.stock === 0 || portalClosed) || (userCanEditOrders && !orderRows.length);

    const { productsMaterials } = product;

    let productImageUrl = false;

    if (productsMaterials.length) {
        productImageUrl = `${getUploadsBaseUrl()}${productsMaterials[0].material.absolutePath}_XS`;
    }

    const getStockIndicatorClass = (stock) => {
        let stockIndicatorClass = 'success';
        if(stock < 10) {
            stockIndicatorClass = 'warning';
        }
        if (!stock) {
            stockIndicatorClass = 'success';
        }
        if (stock === 0) {
            stockIndicatorClass = 'danger';
        }
        return stockIndicatorClass;
    };

    const handleProductAdd = () => {
        if (!isAdded) {
            addProductToCart(product, eventID, partnerPortalSettings);
        } else {
            const orderRow = orderRows.find(or => or.productID === product.productID);
            if (orderRow) {
                removeProductFromCart(orderRow.orderRowID);
            }
        }
    };

    return (
        <div className="row productListItem DataListItem align-items-center">
            <div
                className="col-md-4 d-flex align-items-center"
                style={{ cursor: 'pointer' }}
                onClick={() => setModalShow(true)}
            >
                <div className="mr-3">
                   {productImageUrl ?
                        <img
                            src={productImageUrl}
                            alt="product"
                            style={{ width: '75px', height: 'auto' }}
                        />
                    : <div style={{ width: '75px', height: 'auto' }} />}
                </div>
                <div>
                    <span style={{fontWeight: 'bold'}}>{product.name}</span> {product.bundledProducts && `| ${product.bundledProducts.length} ${t('products.n_products')}`} <br />
                    <span>{product.sku && `| ${product.sku}`}</span>
                </div>
            </div>
            <div className="col-md-2 align-middle">
                <span style={{ fontWeight: 'bold' }}>
                <Badge pill variant={getStockIndicatorClass(product.stock)}>&nbsp;</Badge>
                </span>
                <span>
                    {product.stock ? 
                        <span>
                            {' ' + product.stock + ' ' + t('products.pcs_in_stock')}
                        </span> : product.stock === 0 ? 
                        <span> {t('products.out_of_stock')}</span> : 
                        <span> {t('products.in_stock')}</span>
                    }
                </span>
            </div>
            <div className="col-md-3 pull-right">
                <div className="pull-right">
                    {vat ?
                        product.totalPriceRounded + ' € ('  + product.taxPercentRounded + ' %)'
                        :
                        product.priceRounded + ' € (0.00 %)'
                    }
                </div>
            </div>
            <div className="col-md-3">
                <Button
                    className="float-right"
                    variant={isAdded ? 'danger' : 'primary'}
                    size="sm"
                    disabled={addToCartDisabled}
                    onClick={handleProductAdd}
                >
                    {isAdded ? t('products.remove_from_cart') : t('products.add_to_cart')}
                </Button>
            </div>
            <ProductModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                product={product}
                addProductToCart={handleProductAdd}
                vat={vat}
                portalClosed={portalClosed}
                isAdded={isAdded}
                addToCartDisabled={addToCartDisabled}
            />
        </div>
    )
}

ProductListItem.propTypes = {
    product: PropTypes.object
}

export default ProductListItem;